<template>
  <div class="content">
    <div class="head">
      <div class="product" @click="todetail">
        <div class="product-img">
          <img :src="product.image" alt="">
        </div>
        <div class="product-info">
          <div class="product-title">{{product.title}}</div>
          <div class="product-tag">
            <span v-for="(item,index) in product.tags" :key="index" v-if="index < 3">{{item}}</span>
          </div>
        </div>
        <div class="icon">
          <img :src="public_path + '/static/images/arrow_right.svg'" alt="">
        </div>
      </div>
    </div>
    <div class="form">
      <div class="item" @click="toModel">
        <span class="item-title">选择车型</span>
        <span v-if="!order.car_model" class="item-value"><span>请选择您的教练车型</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
        <span v-if="order.car_model" class="item-value item-value-con"><span>{{order.car_model}}</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
      <div class="item" @click="pikerTicket">
        <span class="item-title">设备版本</span>
        <span class="item-value"><span>{{order.dev_versions == 1 ? '中控版本' : '副驾驶版本'}}</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
      <div class="item">
        <span class="item-title">数量</span>
        <div class="num">
          <div class="before" @click="subtract">-</div>
          <input class="input input-num" type="tel" v-model="order.num" >
          <div class="after" @click="add">+</div>
        </div>
      </div>
      <div class="item">
        <span class="item-title">收货人姓名</span>
        <input type="text" class="input" v-model="order.name" placeholder="请输入您的姓名">
      </div>
      <div class="item">
        <span class="item-title">联系方式</span>
        <input type="tel" class="input" v-model="order.mobile" placeholder="请输入您的手机号">
      </div>
      <div class="item" @click="toAddress">
        <span class="item-title">收货地址</span>
        <span v-if="!order.address" class="item-value"><span>请填写您的收货地址</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
        <span v-if="order.address" class="item-value item-value-con"><span>{{order.address.province}}{{order.address.city}}{{order.address.district}}{{order.address.address}}</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
      <div class="item" @click="toRegisterCoach" v-if="product.type==0">
        <span class="item-title">退押金账号</span>
        <span v-if="!order.registerCoach" class="item-value"><span>请填写您账号信息</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
        <span v-if="order.registerCoach" class="item-value item-value-con"><span>{{order.registerCoach.mobile}}</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
    </div>
    <div class="price">
      <div class="item" @click="toRemark">
        <span class="item-title">备注</span>
        <span v-if="!order.remark" class="item-value"><span>非必填</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
        <span v-if="order.remark" class="item-value item-value-con"><span class="remark">{{order.remark}}</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
    </div>
    <div class="price">
      <div class="price-item">
        <div class="price-title">{{order.type==0 ? '设备押金' : '设备售价'}}</div>
        <div class="price-value">{{product.price}}元/台</div>
      </div>
      <div class="price-item">
        <div class="price-title">支付金额</div>
        <div class="price-value" style="color: #FD5A41">{{product.price ? (product.price * order.num).toFixed(2) : 0}}元</div>
      </div>
    </div>
    <!-- <div class="pact" @click="toLeasePact"><span>设备租赁须知</span><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></div> -->
    <div class="agree" v-if="product.type==0"><el-checkbox v-model="agree">您已阅读并同意</el-checkbox><a class="xieyi" @click="toLeasePact">《路考仪租赁须知及协议》</a></div>
    <!-- <div class="agree"><label><input type="checkbox">您已阅读并同意 <a @click="toLeasePact">《路考仪租赁须知及协议》</a> </label></div> -->
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
    <button class="submit" @click="submitorder">提交订单</button>
    <div class="piker" v-if="piker" @click="pikerTicket">
      <div class="piker-item">
        <div :class="order.dev_versions == 0 ? 'select' : ''" @click.stop="selectTicket(0)">副驾驶版本</div>        
        <div :class="order.dev_versions == 1 ? 'select' : ''" @click.stop="selectTicket(1)">中控版本</div>
      </div>
    </div>
  </div>
</template>
<script>
import detailItem from '@/components/detail_item'
import _wx from '../../../static/js/chelun-wx-1.1.js'
// import cjjl from '../../../static/js/chaojijiaolian-jl.js'
import { getEcmallProduct, ecmallOrder } from '@/http/api'
import URL from '../../../static/js/url.js'
import bus from '../../assets/js/eventBus'
import dialogItem from '@/components/dialog'
import { baseUrl } from '../../http/env.js'
import Vue from 'vue'
import { Checkbox } from 'element-ui'
Vue.use(Checkbox)
const reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/

export default {
  components: {
    'detail-item': detailItem,
    'dialog-item': dialogItem
  },
  data () {
    return {
      agree: false,
      public_path: process.env.PUBLICK_PATH,
      serialnumber: '',
      showDialog: false,
      order: {
        num: 1,
        dev_versions: 0
      },
      product: {},
      uid: URL.getQueryString('coach_id') || '',
      channel_no: URL.getQueryString('channel_no') || '',
      registerCoach: '',
      piker: false,
      token: URL.getQueryString('_token') || '',
      type: URL.getQueryString('type') || '',
      agent_id: URL.getQueryString('agent_id') || '0'
    }
  },
  methods: {
    getEcmallProduct () {
      let id = this.$route.query.id
      getEcmallProduct ({id: id}).then(res => {
        console.log(res)
        if (res.code === 0) {
          let product = res.data
          product.tags = product.tags.split('；')
          this.product = product
        }
      })
    },
    pikerTicket () {
      if (this.piker) {
        this.piker = false
      } else {
        this.piker = true
      }
    },
    selectTicket (ticket) {
      this.order.dev_versions = ticket
      this.piker = false
    },
    toLeasePact () {
      this.$router.push({
        path: `/leasePact?price=${this.product.price}`
      })
    },
    todetail () {
      if (this.product.type == '0') {
        this.$router.push({
          path: '/ecmallshare',
          query: {detail: 1}
        })
      } else if (this.product.type == '1') {
        this.$router.push({
          path: '/ecmallsell',
          query: {detail: 1}
        })
      }
    },
    submitorder () {
      if (!this.order.name) {
        this.showDia('请填写姓名')
      } else if (!this.order.mobile) {
        this.showDia('请填写手机号')
      } else if (!reg.test(this.order.mobile)) {
        this.showDia('请输入正确的的手机号码')
      } else if (!this.order.address) {
        this.showDia('请填写收货地址')
      } else if (!this.order.registerCoach && this.product.type == 0 ) {
        this.showDia('请填写退押金账号')
      } else if (!this.agree && this.product.type == 0) {
        this.showDia('请阅读并同意《路考仪租赁须知及协议》')
      } else {
        if (this.channel_no == 'cjjlapp') {
          localStorage.setItem('cjjlapp_token', this.token)
        } else if (this.channel_no == 'agent') {
          localStorage.setItem('token', this.token)
        } else {
          localStorage.setItem('other_token', this.token)
        }
        localStorage.setItem('channel_no', this.channel_no)
        let data = {
          dev_version: this.order.dev_versions,
          channel_no: this.channel_no,
          channel_uid: this.token,
          type: this.product.type,
          product_id: this.product.id,
          receiver: this.order.name,
          mobile: this.order.mobile,
          province: this.order.address.province,
          city: this.order.address.city,
          district: this.order.address.district,
          address: this.order.address.address,
          num: this.order.num,
          coach_id: +this.type === 0 ? this.order.registerCoach.id : 0,
          pay_type: this.channel_no === 'cjjl' ? 'app' : 'wap',
          car_model: this.order.car_model,
          remark: this.order.remark,
          agent_id: this.agent_id
        }
        ecmallOrder(data).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.serialnumber = res.data.data.serial_number
            this.amount = res.data.data.amount
            if (_wx.isWx) {
              this.channel = res.data.data.channels[1]
              window.location.href = `${baseUrl}/agt/pay/get_openid`
            } else {
              this.channel = res.data.data.channels[0]
              this.$router.push({
                path: '/pay',
                query: {id: res.data.data.id, channel_no: this.channel_no, channel_uid: this.token}
              })
            }
            let pay = {
              order_no: res.data.data.order_no,
              serialnumber: this.serialnumber,
              channel: this.channel,
              amount: this.amount,
              id: res.data.data.id,
              channel_no: this.channel_no,
              channel_uid: this.token
            }
            sessionStorage.setItem('pay', JSON.stringify(pay))
            sessionStorage.setItem('pay_type', 'pay')
          } else {
            this.showDia(res.msg)
          }
        }).catch(err => {
          this.showDia(err.msg)
        })
      }
    },
    add () {
      this.order.num = +this.order.num + 1
    },
    subtract () {
      let num = this.order.num
      if (num > 1) {
        this.order.num -= 1
      } else {
        // return
      }
    },
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    toAddress () {
      this.$router.push({
        path: '/address'
      })
    },
    toRegisterCoach () {
      this.$router.push({
        path: '/registerCoach'
      })
    },
    toRemark () {
      this.$router.push({
        path: '/buyRemark'
      })
    },
    toModel () {
      this.$router.push({
        path: '/buyModel'
      })
    }
  },
  mounted () {
    let carModel = sessionStorage.car_model
    let remark = sessionStorage.remark
    let address = sessionStorage.address
    let order = sessionStorage.order
    let registerCoach = sessionStorage.registerCoach
    let userInfo = sessionStorage.userInfo ? JSON.parse(sessionStorage.userInfo) : null
    if (order) {
      this.order = JSON.parse(order)
    }
    if (address) {
      this.order.address = JSON.parse(address)
    }
    if (registerCoach) {
      this.order.registerCoach = JSON.parse(registerCoach)
    }
    if (userInfo) {
      this.order.mobile = userInfo.mobile
      this.order.name = userInfo.contact
    }
    if (remark) {
      this.order.remark = remark
    }
    if (carModel) {
      this.order.car_model = carModel
    }
    this.getEcmallProduct()
  },
  beforeDestroy () {
    sessionStorage.setItem('order', JSON.stringify(this.order))
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
  background: #f5f5f5;
  -webkit-overflow-scrolling: touch;
  .head {
    padding: .3rem;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    .product {
      widows: 100%;
      display: flex;
      align-items: center;
      padding: .3rem;
      box-shadow: 0px 2px 30px 0px rgba(222, 225, 225, 0.5);
      .product-img {
        img {
          width: 2rem;
          height: 1.2rem;
        }
      }
      .product-info {
        margin-left: .34rem;
        .product-title {
          font-size: .34rem;
        }
        .product-tag {
          margin-top: .2rem;
          span {
            display: inline-block;
            height: .34rem;
            // width: 1.22rem;
            padding: 0 .12rem;
            text-align: center;
            color: #fff;
            margin-right: .2rem;
            font-size: .24rem;
            line-height: .34rem;
            border-radius: .17rem;
            &:first-child {
              background:linear-gradient(156.1deg,rgba(249,184,146,1),rgba(251,107,103,1));
            }
            &:last-child {
              background:linear-gradient(156.1deg,rgba(96,190,255,1),rgba(40,146,232,1));
            }
          }
        }
      }
      .icon {
        flex: 1;
        img {
          float: right;
          width: .14rem;
          height: .25rem;
        }
      }
    }
  }
  .form {
    width: 100%;
    padding: 0 .3rem;
    box-sizing: border-box;
    background: #fff;
    .item {
      height: 1.3rem;
      width: 100%;
      border-bottom: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      .item-title {
        font-size: .3rem;
        display: inline-block;
        width: 1.55rem;
        margin-right: .5rem;
        font-weight: 600;
        text-align-last: justify;
      }
      > input {
        font-size: .28rem;
        width: 4.85rem;
        background: #fff;
        text-align: right;
      }
      .num {
        width: 4.85rem;
        text-align: right;
      }
      .input-num {
        width: .8rem;
        text-align: center
      }
      .before,
      .after {
        display: inline-block;
        width: .3rem;
        height: .3rem;
        font-size: .3rem;
        border: .02rem solid #e3e3e3;
        line-height: .302rem;
        text-align: center;
        color: rgba(51, 51, 51, .3);
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
      }
      .item-content {
        font-size: .28rem;
        width: 4.93rem;
        color: rgba(51, 51, 51, .5);
      }
      .city {
        color: #333;
      }
      .item-value {
        text-align: right;
        flex: 1;
        font-size: .28rem;
        color:rgba(51, 51, 51, .6);
        span {
          display: inline-block;
          vertical-align: middle;
          line-height: 1;
          width: 4.5rem;
        }
        img {
          display: inline-block;
          width: .14rem;
          height: .25rem;
          margin-left: .18rem;
          vertical-align: middle;
        }
      }
      .item-value-con {
        color: #333;
      }
    }
  }
  .price {
    background: #fff;
    margin-top: .3rem;
    padding: 0 .3rem;
    .item {
      height: 1.3rem;
      width: 100%;
      border-bottom: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      .item-title {
        font-size: .3rem;
        display: inline-block;
        width: 1.55rem;
        margin-right: .5rem;
        font-weight: 600;
        text-align-last: justify;
      }
      > input {
        font-size: .28rem;
        width: 4.85rem;
        background: #fff;
        text-align: right;
      }
      .num {
        width: 4.85rem;
        text-align: right;
      }
      .input-num {
        width: .8rem;
        text-align: center
      }
      .before,
      .after {
        display: inline-block;
        width: .3rem;
        height: .3rem;
        font-size: .3rem;
        border: .02rem solid #e3e3e3;
        line-height: .302rem;
        text-align: center;
        color: rgba(51, 51, 51, .3);
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
      }
      .item-content {
        font-size: .28rem;
        width: 4.93rem;
        color: rgba(51, 51, 51, .5);
      }
      .city {
        color: #333;
      }
      .item-value {
        text-align: right;
        flex: 1;
        font-size: .28rem;
        color:rgba(51, 51, 51, .6);
        span {
          display: inline-block;
          vertical-align: middle;
          line-height: 1;
          width: 4.5rem;
        }
        .remark {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 3.5rem;
        }
        img {
          display: inline-block;
          width: .14rem;
          height: .25rem;
          margin-left: .18rem;
          vertical-align: middle;
        }
      }
      .item-value-con {
        color: #333;
      }
    }
    .price-item {
      height: 1rem;
      display: -webkit-flex;
      align-items: center;
      font-size: .3rem;
      border-bottom: 1px solid #ebebeb;
      .price-title {
        font-weight: 600;
        text-align: left;
        flex: 1;
      }
      .price-value {
        text-align: right;
        flex: 1;
      }
    }
  }
  .submit {
    display: block;
    width: 6.90rem;
    height: .90rem;
    line-height: .9rem;
    background: rgba(2, 179, 137, 1);
    border-radius: .45rem;
    color: #fff;
    margin: .2rem auto .3rem;
    font-size: .32rem;
  }
}
.pact {
  margin-top: .2rem;
  text-align: right;
  margin-right: .3rem;
  font-size: .26rem;
  color: #999;
  span {
    display: inline-block;
    vertical-align: middle;
    width: 4.5rem;
  }
  img {
    display: inline-block;
    width: .14rem;
    height: .35rem;
    margin-left: .18rem;
    vertical-align: middle;
  }
}
.agree {
  color: #309FF6;
  font-size: 14px;
  text-align: center;
  margin-top: .3rem;
  margin-bottom: .3rem;
  .el-checkbox {
    display: inline-block;
    vertical-align: middle;
    color: #309FF6;
  }

  .xieyi {
    display: inline-block;
    vertical-align: middle;
  }
}
.piker {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  .piker-item {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    div {
      text-align: center;
      font-size: .3rem;
      height: 1rem;
      line-height: 1rem;
      background: #fff;
      margin-top: .1rem;
    }
    .select {
      color: #02B389;
    }
  }
}
</style>
<style>
.mint-cell {
  background: none;
}
.mint-checkbox-core {
  width: .24rem;
  height: .24rem;
}
.mint-checkbox-label {
  font-size: .26rem;
}
.mint-checkbox-core::after {
  top: .02rem;
  left: .07rem;
  width: .06rem;
  height: .12rem;
}
input[type="checkbox"] {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/pages/buy/Buy_1.vue